module.exports = __webpack_public_path__ + "img/282.7c5df794.png";